import React from 'react';
import {NextPage} from 'next';
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import * as styled from "../src/components/subpageHeroArea/ApplicationSubpageStyled";
import CareerApplication from "../src/components/careerApplication/CareerApplication";
import BreadcrumbComp from "../src/components/breadcrumb/BreadcrumbComp";
import GeneralFormCareerComp from "../src/components/generalForm/GeneralFormCareerComp";
import TextArea from "../src/components/textArea/TextArea";
import ButtonComp from "../src/components/buttons/buttonComp/buttonComp";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import {NavigationURLs} from "../src/functions/NavigationFunctions";

const DijitalSatisData = {
    title: 'IT Stajyeri',
    text: '<p> Firmamızın Bilgi Teknolojileri departmanında yetiştirilmek üzere IT stajyerleri arıyoruz. </p> <p class="fw-bold"> Aranan özellikler </p> <ul> <li> IT Departmanı’yla ilgili tüm iletişimlerin takibi </li> <li> IT departmanına destek olunması, </li> <li> Servicedesk’e gelen sorunların takibi, </li> <li> IT Helpdesk tarafında kullanıcı sorunlarına destek olunması, (notebook, pc, printer, internet, cep telefonu vb.) </li> <li> IT ile ilgili dokümantasyon yapılması ve düzenlenmesi, </li> <li> IT uygulamalarında oluşacak ihtiyaçlara cevap verilmesi </li> <li> Gerektiğinde projelere destek olunması, </li> </ul> <p class="fw-bold"> Çalışma süresi </p> <p> Yarı zamanlı </p>'
}

const KariyerBasvuru: NextPage = () => {
    const breadcrumbItKariyer = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kariyer', link: NavigationURLs.career},
        { label: 'IT Stajyeri'}
    ];
    return (
        <React.Fragment>
            <HtmlHead pageTitle="Kariyer Başvuru | Pembe Panjur"
                      description="Pembe Panjur kariyer başvuru sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout
                backgroundColor={'#D2147D'}
                loginButtonText={false}
                sloganOne={''}
                sloganTwo={''}
                homeButton={true}
                className={'career_page'}
                extraChildren={
                    <React.Fragment>
                        <styled.ApplicationSubpage className={'mobile-bgc-white'}>
                            <styled.ApplicationSubpageContainer className={'mb-0'}>
                                <styled.ApplicationSubpageWrapper>
                                    <BreadcrumbComp/>
                                    <CareerApplication title={DijitalSatisData.title} text={DijitalSatisData.text} breadcrumb={breadcrumbItKariyer}/>
                                </styled.ApplicationSubpageWrapper>
                                <styled.ApplicationSubpageWrapper>
                                    <GeneralFormCareerComp title={'Başvuruyu gönder'} textareaTitle={'Hakkında'}
                                                     textareaPlaceholder={'Lütfen kısaca hakkınızda bilgilendirme yapın.'}
                                                     careerUpload={true} pageTitle={'it_stajyeri'}
                                    />
                                </styled.ApplicationSubpageWrapper>
                            </styled.ApplicationSubpageContainer>
                        </styled.ApplicationSubpage>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea desktopHidden={true}>
                    <styled.CareerApplicationHeroAreaContent>
                        <TextArea>
                            <h2>
                                Pembe Panjur KARİYER
                            </h2>
                        </TextArea>
                        <ButtonComp fullWidth={true} backgroundColor={'#FFFFFF'} visible={false} uppercase={true} textColor={false} url={'#'}>
                            <React.Fragment>
                                IT Stajyeri
                            </React.Fragment>
                        </ButtonComp>
                    </styled.CareerApplicationHeroAreaContent>
                </SubpageHeroArea>
            </WaveLayout>
        </React.Fragment>
    );
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default KariyerBasvuru;
